/* unplugin-vue-components disabled */import { render } from "./unsupported.vue?vue&type=template&id=266941f2&scoped=true"
import script from "./unsupported.vue?vue&type=script&lang=js"
export * from "./unsupported.vue?vue&type=script&lang=js"

import "./unsupported.vue?vue&type=style&index=0&id=266941f2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266941f2"],['__file',"src/pages/unsupported/unsupported.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "266941f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('266941f2', __exports__)) {
    api.reload('266941f2', __exports__)
  }
  
  module.hot.accept("./unsupported.vue?vue&type=template&id=266941f2&scoped=true", () => {
    api.rerender('266941f2', render)
  })

}


export default __exports__